const DHIAWS_PROFILER = '.dhiaws';
const EFC_PROFILER = '.efinancial';
const LOCALHOST_PROFILER = 'localhost';

class Utils {

  static objectIsEmpty(obj) {

    if (objectIsInvalid(obj)) {
      throw new Error('object is required');
    }

    for (let key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }

    return true;

  };

  static stringIsInvalidOrEmpty(str) {

    return typeof str !== 'string'
      || str === '';

  };

  static arrayIsInvalidOrEmpty(arr) {

    return !(arr instanceof Array)
      || arr.length < 1;

  };


  static getCookieDomain(){

    // HACK: Frontoffice sets the cookie domain as the Public suffix, this a simple way to mimic that until we move to a better solution

    let hostname = window.location.hostname;
    let dhiawsIndex = hostname.indexOf(DHIAWS_PROFILER);
    let efinancialIndex = hostname.indexOf(EFC_PROFILER);

    let domain;
    if (dhiawsIndex > -1) {
      domain = hostname.substr(dhiawsIndex + 1);
    } else if (efinancialIndex > -1) {
      domain = hostname.substr(efinancialIndex + 1);
    } else if (hostname === LOCALHOST_PROFILER) {
      domain = hostname;
    } else {
      throw new Error('hostname not supported');
    }

    return domain;

  }

}

let objectIsInvalid = function (obj) {

  return typeof obj !== 'object';

};

export default Utils;



// WEBPACK FOOTER //
// ./src/library/services/Utils.js